export default __webpack_public_path__ + "static/media/martin-miguel.6231af0b.jpg";